import { env } from '@/utils/enums/environment';

export class Braspag {
  static _isProductionMode = process.env.currentEnv === 'prd';
  static _provider = env.PAYMENT_PROVIDER;
  static _defaultPost = {
    EnableBinQuery: env.PAYMENT_PROVIDER === 'cielo',
    EnableVerifyCard: env.PAYMENT_PROVIDER === 'cielo',
  };

  static getCieloBaseUrl() {
    return (Braspag._isProductionMode)
      ? 'https://transaction.cieloecommerce.cielo.com.br'
      : 'https://transactionsandbox.cieloecommerce.cielo.com.br';
  }

  static getBraspagBaseUrl() {
    return (Braspag._isProductionMode)
      ? 'https://transaction.pagador.com.br'
      : 'https://transactionsandbox.pagador.com.br';
  }

  static getUrl() {
    const baseUrl = Braspag._provider === 'cielo'
      ? Braspag.getCieloBaseUrl()
      : Braspag.getBraspagBaseUrl();

    return `${baseUrl}/post/api/public/v1/card`;
  }

  static async getPaymentToken(form) {
    const postForm = { ...Braspag._defaultPost, ...form };

    const rawResponse = await fetch(Braspag.getUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postForm),
      mode: 'cors',
    });

    return await rawResponse.json();
  }
}
